function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "a",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "m10.2690891 0v11.5424483h-5.52030136v5.7712241h-4.62181283c-.01961714.1670378-.03550181.3344472-.0516241.5018456-.28885278 3.1443041.26006189 6.0441142 1.5212194 8.5235334l.42343221.7606097c.25378406.4558715.5498323.8839935.86254708 1.301662.31232987.4171541.42298456.6480382.61946563.9252778 3.33442787 3.7477401 8.30509837 5.5516667 14.04383477 5.5516667 12.7088277 0 23.4946509-5.6302031 28.2680204-18.2781569 3.3866471.3475205 6.6352592-.5208886 8.1157839-3.4109816-2.3583304-1.3609212-5.3894125-.9247193-7.1356168-.0470481l4.6263889-13.142081-18.0664407 11.5424483h-5.7712241v-11.5424483z",
  fill: "#fff",
  fillRule: "evenodd"
}));

var _ref3 = /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "m10.2690891 0v11.5424483h-5.52030136v5.7712241h-4.62181283c-.01961714.1670378-.03550181.3344472-.0516241.5018456-.28885278 3.1443041.26006189 6.0441142 1.5212194 8.5235334l.42343221.7606097c.25378406.4558715.5498323.8839935.86254708 1.301662.31232987.4171541.42298456.6480382.61946563.9252778 3.33442787 3.7477401 8.30509837 5.5516667 14.04383477 5.5516667 12.7088277 0 23.4946509-5.6302031 28.2680204-18.2781569 3.3866471.3475205 6.6352592-.5208886 8.1157839-3.4109816-2.3583304-1.3609212-5.3894125-.9247193-7.1356168-.0470481l4.6263889-13.142081-18.0664407 11.5424483h-5.7712241v-11.5424483z",
  fill: "#fff",
  fillRule: "evenodd"
}));

var _ref4 = /*#__PURE__*/React.createElement("mask", {
  id: "c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "m10.2690891 0v11.5424483h-5.52030136v5.7712241h-4.62181283c-.01961714.1670378-.03550181.3344472-.0516241.5018456-.28885278 3.1443041.26006189 6.0441142 1.5212194 8.5235334l.42343221.7606097c.25378406.4558715.5498323.8839935.86254708 1.301662.31232987.4171541.42298456.6480382.61946563.9252778 3.33442787 3.7477401 8.30509837 5.5516667 14.04383477 5.5516667 12.7088277 0 23.4946509-5.6302031 28.2680204-18.2781569 3.3866471.3475205 6.6352592-.5208886 8.1157839-3.4109816-2.3583304-1.3609212-5.3894125-.9247193-7.1356168-.0470481l4.6263889-13.142081-18.0664407 11.5424483h-5.7712241v-11.5424483z",
  fill: "#fff",
  fillRule: "evenodd"
}));

var _ref5 = /*#__PURE__*/React.createElement("mask", {
  id: "d",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "m10.2690891 0v11.5424483h-5.52030136v5.7712241h-4.62181283c-.01961714.1670378-.03550181.3344472-.0516241.5018456-.28885278 3.1443041.26006189 6.0441142 1.5212194 8.5235334l.42343221.7606097c.25378406.4558715.5498323.8839935.86254708 1.301662.31232987.4171541.42298456.6480382.61946563.9252778 3.33442787 3.7477401 8.30509837 5.5516667 14.04383477 5.5516667 12.7088277 0 23.4946509-5.6302031 28.2680204-18.2781569 3.3866471.3475205 6.6352592-.5208886 8.1157839-3.4109816-2.3583304-1.3609212-5.3894125-.9247193-7.1356168-.0470481l4.6263889-13.142081-18.0664407 11.5424483h-5.7712241v-11.5424483z",
  fill: "#fff",
  fillRule: "evenodd"
}));

var _ref6 = /*#__PURE__*/React.createElement("mask", {
  id: "e",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "m10.2690891 0v11.5424483h-5.52030136v5.7712241h-4.62181283c-.01961714.1670378-.03550181.3344472-.0516241.5018456-.28885278 3.1443041.26006189 6.0441142 1.5212194 8.5235334l.42343221.7606097c.25378406.4558715.5498323.8839935.86254708 1.301662.31232987.4171541.42298456.6480382.61946563.9252778 3.33442787 3.7477401 8.30509837 5.5516667 14.04383477 5.5516667 12.7088277 0 23.4946509-5.6302031 28.2680204-18.2781569 3.3866471.3475205 6.6352592-.5208886 8.1157839-3.4109816-2.3583304-1.3609212-5.3894125-.9247193-7.1356168-.0470481l4.6263889-13.142081-18.0664407 11.5424483h-5.7712241v-11.5424483z",
  fill: "#fff",
  fillRule: "evenodd"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "m37.0079998 11.4750843h5.7376005v5.8652524h2.9011115c1.3396894 0 2.717677-.2386702 3.9864104-.6685687.6234126-.2113874 1.3231585-.5055567 1.9381075-.8755198-.8099411-1.057479-1.2234468-2.3927345-1.3451996-3.7089048-.1652928-1.7901484.1958001-4.12025757 1.4074184-5.52135923l.6031231-.69759471.718693.57772287c1.8094996 1.4537814 3.3312811 3.48515192 3.5995125 5.80088067 2.1787927-.6408844 4.7368175-.4892994 6.6573203.6191144l.7879026.4546269-.4147151.8094016c-1.6241957 3.1700015-5.0197129 4.1519557-8.3394365 3.9781954-4.9675561 12.3725985-15.7824938 18.2301902-28.8955531 18.2301902-6.774639 0-12.9902339-2.5324934-16.52967721-8.5431506-.20751766-.3733681-.38522494-.7637839-.57369129-1.1472491-1.19643348-2.6457808-1.59381112-5.544205-1.32423398-8.4402103l.08090002-.8674581h4.90627746v-5.8652525h5.7376005v-5.73760043h11.4752009v-5.73760047h6.8852385v11.4752009",
  fill: "#394d54"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#a)",
  transform: "translate(8.801043 .501729)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(22.278005 -5.283159)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0h4.97266486v4.97252952h-4.97266486z",
  fill: "#00acd3"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 5.73745133h4.97266486v4.97279857h-4.97266486z",
  fill: "#20c2ef"
}), /*#__PURE__*/React.createElement("path", {
  d: "m.12546139 4.14417784v-4.14417784m.74570489 4.14417784v-4.14417784m.75323006 4.14417784v-4.14417784m.75363154 4.14417784v-4.14417784m.75350106 4.14417784v-4.14417784m.74556939 4.14417784v-4.14417784",
  fill: "#000",
  stroke: "#394d54",
  strokeWidth: 0.56,
  transform: "translate(.485119 6.151642)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1 0 0 -1 28.015605 5.426851)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0h4.97266486v4.97252952h-4.97266486z",
  fill: "#00acd3"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 5.73745133h4.97266486v4.97279857h-4.97266486z",
  fill: "#20c2ef"
}), /*#__PURE__*/React.createElement("path", {
  d: "m.61058046 4.55821936v-4.14417784m.74570489 4.14417784v-4.14417784m.75323006 4.14417784v-4.14417784m.75363154 4.14417784v-4.14417784m.75350106 4.14417784v-4.14417784m.74556939 4.14417784v-4.14417784",
  fill: "#000",
  stroke: "#394d54",
  strokeWidth: 0.56
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-.672397 6.192042)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0h4.97266486v4.97252952h-4.97266486z",
  fill: "#00acd3"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 5.73745133h4.97266486v4.97279857h-4.97266486z",
  fill: "#20c2ef"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  stroke: "#394d54"
}, /*#__PURE__*/React.createElement("path", {
  d: "m.61058046 4.55821936v-4.14417784m.74570489 4.14417784v-4.14417784m.75323006 4.14417784v-4.14417784m.75363154 4.14417784v-4.14417784m.75350106 4.14417784v-4.14417784m.74556939 4.14417784v-4.14417784",
  strokeWidth: 0.56
}), /*#__PURE__*/React.createElement("path", {
  d: "m.12546139 4.14417784v-4.14417784m.74570489 4.14417784v-4.14417784m.75323006 4.14417784v-4.14417784m.75363154 4.14417784v-4.14417784m.75350106 4.14417784v-4.14417784m.74556939 4.14417784v-4.14417784",
  strokeWidth: 1.56,
  transform: "translate(.485119 6.151642)"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1 0 0 -1 5.065203 16.902052)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0h4.97266486v4.97252952h-4.97266486z",
  fill: "#00acd3"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 5.73745133h4.97266486v4.97279857h-4.97266486z",
  fill: "#20c2ef"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  stroke: "#394d54",
  strokeWidth: 0.56
}, /*#__PURE__*/React.createElement("path", {
  d: "m.61058046 4.55821936v-4.14417784m.74570489 4.14417784v-4.14417784m.75323006 4.14417784v-4.14417784m.75363154 4.14417784v-4.14417784m.75350106 4.14417784v-4.14417784m.74556939 4.14417784v-4.14417784"
}), /*#__PURE__*/React.createElement("path", {
  d: "m.12546139 4.14417784v-4.14417784m.74570489 4.14417784v-4.14417784m.75323006 4.14417784v-4.14417784m.75363154 4.14417784v-4.14417784m.75350106 4.14417784v-4.14417784m.74556939 4.14417784v-4.14417784",
  transform: "translate(.485119 6.151642)"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(10.802804 6.192042)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0h4.97266486v4.97252952h-4.97266486z",
  fill: "#00acd3"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 5.73745133h4.97266486v4.97279857h-4.97266486z",
  fill: "#20c2ef"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  stroke: "#394d54",
  strokeWidth: 0.56
}, /*#__PURE__*/React.createElement("path", {
  d: "m.61058046 4.55821936v-4.14417784m.74570489 4.14417784v-4.14417784m.75323006 4.14417784v-4.14417784m.75363154 4.14417784v-4.14417784m.75350106 4.14417784v-4.14417784m.74556939 4.14417784v-4.14417784"
}), /*#__PURE__*/React.createElement("path", {
  d: "m.12546139 4.14417784v-4.14417784m.74570489 4.14417784v-4.14417784m.75323006 4.14417784v-4.14417784m.75363154 4.14417784v-4.14417784m.75350106 4.14417784v-4.14417784m.74556939 4.14417784v-4.14417784",
  transform: "translate(.485119 6.151642)"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1 0 0 -1 16.540404 16.902052)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0h4.97266486v4.97252952h-4.97266486z",
  fill: "#00acd3"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 5.73745133h4.97266486v4.97279857h-4.97266486z",
  fill: "#20c2ef"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  stroke: "#394d54",
  strokeWidth: 0.56
}, /*#__PURE__*/React.createElement("path", {
  d: "m.61058046 4.55821936v-4.14417784m.74570489 4.14417784v-4.14417784m.75323006 4.14417784v-4.14417784m.75363154 4.14417784v-4.14417784m.75350106 4.14417784v-4.14417784m.74556939 4.14417784v-4.14417784"
}), /*#__PURE__*/React.createElement("path", {
  d: "m.12546139 4.14417784v-4.14417784m.74570489 4.14417784v-4.14417784m.75323006 4.14417784v-4.14417784m.75363154 4.14417784v-4.14417784m.75350106 4.14417784v-4.14417784m.74556939 4.14417784v-4.14417784",
  transform: "translate(.485119 6.151642)"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(22.278005 6.192042)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0h4.97266486v4.97252952h-4.97266486z",
  fill: "#00acd3"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 5.73745133h4.97266486v4.97279857h-4.97266486z",
  fill: "#20c2ef"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  stroke: "#394d54",
  strokeWidth: 0.56
}, /*#__PURE__*/React.createElement("path", {
  d: "m.61058046 4.55821936v-4.14417784m.74570489 4.14417784v-4.14417784m.75323006 4.14417784v-4.14417784m.75363154 4.14417784v-4.14417784m.75350106 4.14417784v-4.14417784m.74556939 4.14417784v-4.14417784"
}), /*#__PURE__*/React.createElement("path", {
  d: "m.12546139 4.14417784v-4.14417784m.74570489 4.14417784v-4.14417784m.75323006 4.14417784v-4.14417784m.75363154 4.14417784v-4.14417784m.75350106 4.14417784v-4.14417784m.74556939 4.14417784v-4.14417784",
  transform: "translate(.485119 6.151642)"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1 0 0 -1 28.015605 16.902052)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0h4.97266486v4.97252952h-4.97266486z",
  fill: "#00acd3"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 5.73745133h4.97266486v4.97279857h-4.97266486z",
  fill: "#20c2ef"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  stroke: "#394d54",
  strokeWidth: 0.56
}, /*#__PURE__*/React.createElement("path", {
  d: "m.61058046 4.55821936v-4.14417784m.74570489 4.14417784v-4.14417784m.75323006 4.14417784v-4.14417784m.75363154 4.14417784v-4.14417784m.75350106 4.14417784v-4.14417784m.74556939 4.14417784v-4.14417784"
}), /*#__PURE__*/React.createElement("path", {
  d: "m.12546139 4.14417784v-4.14417784m.74570489 4.14417784v-4.14417784m.75323006 4.14417784v-4.14417784m.75363154 4.14417784v-4.14417784m.75350106 4.14417784v-4.14417784m.74556939 4.14417784v-4.14417784",
  transform: "translate(.485119 6.151642)"
})))), /*#__PURE__*/React.createElement("path", {
  d: "m46.7959545 13.1432476c.3847449-2.989807-1.8527712-5.33832689-3.2404345-6.45332263-1.5990531 1.84874014-1.8475319 6.69400673.6611766 8.73397763-1.4000288 1.2436027-4.3503262 2.3708277-7.3710426 2.3708277h-37.11532203c-.2937666 3.1533539 0 18.3381512 0 18.3381512h54.45024503l-.2475529-22.940365c-2.3583304-1.3609211-5.3908728-.9269906-7.1370772-.0493194",
  fill: "#17b5eb",
  mask: "url(#b)",
  transform: "translate(8.801043 .501729)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m-.26966803 21.8302826v14.3025989h54.45024503v-14.3025989",
  fill: "#000",
  fillOpacity: 0.17,
  mask: "url(#c)",
  transform: "translate(8.801043 .501729)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m19.1109457 34.8506585c-3.397399-1.6122216-5.2622656-3.8037787-6.2998555-6.1963751l-10.32060756.45276 5.26937855 7.0258381z",
  fill: "#d4edf1",
  mask: "url(#d)",
  transform: "translate(8.801043 .501729)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m47.0292775 13.0323023v.0078413c-5.2345479 6.747099-12.742642 12.6411689-20.8030674 15.7375637-7.1901373 2.7620752-13.4590921 2.7753039-17.78415257.5567349-.46573026-.2630474-.92231715-.5549208-1.38007534-.8311817-3.1708242-2.2161501-4.9568482-5.881992-4.80673966-10.7112666h-2.52491056v18.3408876h54.45024503v-24.0885877h-6.2730697z",
  fill: "#000",
  fillOpacity: 0.085,
  mask: "url(#e)",
  transform: "translate(8.801043 .501729)"
})), /*#__PURE__*/React.createElement("path", {
  d: "m11.4483522 29.3656909c3.5543597.1945429 7.347634.2294262 10.6563772-.8076578",
  stroke: "#394d54",
  strokeLinecap: "round",
  strokeWidth: 0.4
}), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "m25.6368415 26.8383991c0 .7575308-.6141408 1.3716719-1.3716714 1.3716719-.7576649 0-1.3719407-.6141411-1.3719407-1.3716719 0-.7575284.6142758-1.3719405 1.3719407-1.3719405.7575306 0 1.3716714.6144121 1.3716714 1.3719405z",
  fill: "#d4edf1"
}), /*#__PURE__*/React.createElement("path", {
  d: "m24.6208882 25.9221595c-.1197373.0692095-.2007716.1988915-.2007716.3472521 0 .2214669.1795388.4007387.401006.4007387.1517212 0 .2835543-.0842599.3516874-.2087025.0481094.1159765.0748528.2433725.0748528.3769513 0 .5425151-.4398444.9823577-.9824927.9823577-.5425139 0-.9826262-.4398426-.9826262-.9823577 0-.5427812.4401123-.9827592.9826262-.9827592.1255161 0 .2452534.023662.3557181.0665196z",
  fill: "#394d54"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 22.6236698h63.8165478c-1.3895451-.3524928-4.3964181-.8286206-3.900537-2.6496774-2.5265792 2.9236894-8.6198853 2.0511247-10.1576556.6094378-1.7124752 2.4837115-11.6815874 1.5396539-12.3768995-.3952275-2.1468075 2.519458-8.7991546 2.519458-10.9460951 0-.6955805 1.9348814-10.664559 2.878939-12.3771667.3952275-1.5377726 1.4416869-7.63053895 2.3142516-10.15738813-.6094378.49588214 1.8210568-2.5109917 2.2971846-3.90080577 2.6496774",
  fill: "#394d54"
})));

function SvgIconDocker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 37,
    viewBox: "0 0 64 37",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocker);
export default __webpack_public_path__ + "static/media/icon-docker.f96a3140.svg";
export { ForwardRef as ReactComponent };